import React, { useState } from "react";
import LoadingButton from "@mui/lab/LoadingButton";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import {
  useLazyGetVehiclesQuery,
  Vehicle,
} from "../../../redux/api/VehiclesApi";
import {
  GridApi,
  gridFilterModelSelector,
  gridSortModelSelector,
  useGridApiContext,
} from "@mui/x-data-grid";
import { Operator, PageRequest } from "../../../common/pagination";
import VehiclesExport from "../../csv-export/VehiclesExport";
import { useTranslation } from "react-i18next";
import { Tooltip } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";

const prepareRequest = (
  apiRef: React.MutableRefObject<GridApi>,
  organizationId: string
): PageRequest<Vehicle> => {
  // don't reflect pagination
  const sortModel = gridSortModelSelector(apiRef);
  const filterModel = gridFilterModelSelector(apiRef);
  const filter = filterModel.items[0];
  const sort = sortModel[0];
  return {
    filterField: filter?.columnField as keyof Vehicle,
    filterOperator: filter?.operatorValue as Operator,
    filterValue: filter?.value,
    sortField: sort?.field as keyof Vehicle,
    sortOrder: sort?.sort,
    organizationId: organizationId,
  };
};

const DownloadVehiclesButton = () => {
  const { t } = useTranslation();
  const apiRef = useGridApiContext<GridApi>();
  const [timestamp, setTimestamp] = useState(0);
  const [trigger, { data, isLoading }] = useLazyGetVehiclesQuery();
  const organization = useSelector(
    (state: RootState) => state.userSettings.organization
  );

  const getData = async () => {
    if (organization) {
      await trigger(prepareRequest(apiRef, organization.publicId));
      setTimestamp(Date.now);
    }
  };

  return (
    <>
      <Tooltip title={t("table.export.csv.tooltip")}>
        <LoadingButton
          variant="outlined"
          size="medium"
          onClick={getData}
          startIcon={<FileDownloadIcon />}
          loading={isLoading}
          loadingPosition="start"
          color="secondary"
        >
          {t("table.export.csv")}
          {!!timestamp && data && (
            // CSVDownload triggers download on mount
            <VehiclesExport key={timestamp} content={data.content} />
          )}
        </LoadingButton>
      </Tooltip>
    </>
  );
};

export default DownloadVehiclesButton;
